import { usePeriodoGestacionalQuery } from 'graphql/hooks.generated'
import { PeriodoGestacional } from 'graphql/types.generated'
import { dateAsYyyyMmDd, toDate } from 'util/date/formatDate'

import { ResultadosExamesModel } from '../../../objetivo/resultados-exames/model-resultadosExames'
import {
  filterResultadosExamesAndConvertToExamePreNatalInput,
  isResultadoExamePreNatal,
} from '../../../objetivo/resultados-exames/util-resultadosExames'
import { convertPeriodoGestacionalToIdadeGestacional } from '../converter-acompanhamentoPreNatal'
import { IdadeGestacionalAcompanhamentoPreNatal } from '../model-acompanhamentoPreNatal'

interface UsePeriodoGestacionalProps {
  prontuarioId?: string
  dumMaisRecente: Date
  dataAtendimento: Date | number
  resultadosExamesAtendimentoAtual?: ResultadosExamesModel
  skip?: boolean
}

export interface UsePeriodoGestacionalResult
  extends Omit<PeriodoGestacional, 'idadeGestacional' | 'isEcografico' | 'dataInicioGestacao' | 'dataProvavelParto'> {
  dataInicioGestacao: Date
  dataProvavelParto?: Date
  idadeGestacional: IdadeGestacionalAcompanhamentoPreNatal
  loading: boolean
}

export function usePeriodoGestacional({
  prontuarioId,
  dumMaisRecente,
  dataAtendimento,
  resultadosExamesAtendimentoAtual,
  skip,
}: UsePeriodoGestacionalProps): UsePeriodoGestacionalResult {
  const resultadosExamesPreNatalAsInput =
    resultadosExamesAtendimentoAtual &&
    filterResultadosExamesAndConvertToExamePreNatalInput(resultadosExamesAtendimentoAtual, isResultadoExamePreNatal)

  const { data, loading } = usePeriodoGestacionalQuery({
    skip: !prontuarioId || !dumMaisRecente || !dataAtendimento || skip,
    variables: {
      input: {
        prontuarioId,
        dum: dumMaisRecente,
        dataAtendimento: dateAsYyyyMmDd(dataAtendimento),
        resultadosExamesPreNatalAtendimentoAtual: resultadosExamesPreNatalAsInput,
      },
    },
  })

  const periodoGestacional = data?.periodoGestacional

  return {
    ...periodoGestacional,
    dataInicioGestacao: toDate(periodoGestacional?.dataInicioGestacao),
    dataProvavelParto: toDate(periodoGestacional?.dataProvavelParto),
    idadeGestacional: convertPeriodoGestacionalToIdadeGestacional(periodoGestacional),
    loading,
  }
}
